export var searchLayers = [{
  id: 'Search',
  type: 'search',
  event: true,
  contextualize: function contextualize(_ref) {
    var searchTerm = _ref.searchTerm;
    return {
      searchTerm: searchTerm
    };
  }
}];